export default {
  locale: function locale(state) {
    return state.currentLocale;
  },
  locales: function locales(state) {
    return state.locales;
  },
  homeUrl: function homeUrl(state) {
    return "/".concat(state.currentLocale.market, "/").concat(state.currentLocale.language);
  },
  serviceNumber: function serviceNumber(state) {
    return state.serviceNumber;
  }
};